module.exports = __webpack_public_path__ + "img/main_menu_user.eb6708b7.svg";